import { render, staticRenderFns } from "./FiltersTable.vue?vue&type=template&id=0b28148d"
import script from "./FiltersTable.vue?vue&type=script&lang=js"
export * from "./FiltersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports